import React, { useState, useEffect } from 'react';
import noticeIcon from "../../img/notice_icon.png"
import { makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom"
//import AddIcon from "@mui/icons-material/Add"
import AddIcon from '@material-ui/icons/Add';

import { getNotice } from "../../functions/notice"

const useStyles = makeStyles((theme) => ({

    total: {

        width: "430px",
        borderRadius: "20px",
        boxShadow: "3px 3px 12px #ddd",

        margin: "45px 0 0 0"

    },

    img: {
        width: "30px",
        margin: "2px"

    },

    header: {
        borderRadius: "20px 20px 0 0",
        background: theme.palette.primary.main,
        padding: "15px 15px 15px 25px",
        color: "#fff",
        fontSize: "25px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"

    },
    body: {
        borderRadius: "0 0 20px 20px",
        padding: "25px 25px",
        background: "#fff",
    },
    content: {
        paddingLeft: "10px",
        fontSize: "15px",
        color: "#666666",
        overflow: "hidden",
        textOverflow: "ellipsis",
        //wordBreak: "break-all",
        lineHeight: "30px",
        width: "350px"

    }

}))

const NoticeBanner = () => {

    const style = useStyles();

    const [noticeList, setNoticeList] = useState([]);

    useEffect(() => {

        getNotice().then(res => {
            // console.log(res)
            setNoticeList([...res.reverse()]);
        });

        //   console.log(noticeList)

        return () => {
            console.log("noticebanner unmount")
        }

    }, [])  // 화면이 리로드 될 때마다 호출

    return (
        <div className={style.total}>
            <div className={style.header}>

                <img className={style.img} src={noticeIcon} alt="notice" />
                <span >공지사항</span>
                <Link to="/notice" style={{ textDecoration: "none", color: "#fff" }}  >
                    <AddIcon fontSize="large" />
                </Link>
            </div>
            <div className={style.body}>

                {noticeList.map((item, index) => {
                    return (
                        <div key={index} className={style.content}>
                            {item.title}
                        </div>
                    )
                })}

            </div>

        </div>
    );
};

export default NoticeBanner;